import {makeStyles} from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: '50px',
        textAlign: 'center',
        fontFamily: theme.font.balsamiq + " !important",
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.size.heightHeaderPhone,
        },
    },
    hrTitle: {
        width: '10%',
        height: '2px',
        backgroundColor: theme.palette.secondary.main,
        border: 'none',
        marginBottom: '25px',
    },
    heading: {
        fontFamily: theme.font.balsamiq + " !important",
    },
    typoFooter: {
        marginBottom: '25px',
        marginTop: '25px',
        marginLeft: '25px',
    },
    containerContent:{

      marginBottom:'15px',
    },
}));

export default useStyles;